// frontend/src/hooks/useHeldWhileClosed.js
//
// What a popup shows while it closes. MUI keeps a Dialog on screen through
// its fade-out after `open` turns false, and by then the caller has usually
// cleared what the popup showed; drawn from the live props, the fading popup
// would flip to a blank or a default.
//
// Returns `content` while open, and the content of the last open render
// while closed — null while the popup has never been open. `content` is a
// flat object whose values are compared by identity, so pass primitives or
// values the caller holds in state; a value built during render changes on
// every render and makes React stop with "Too many re-renders".

import { useState } from 'react';

export function useHeldWhileClosed(open, content) {
  const [held, setHeld] = useState(null);
  if (open && (held === null
    || Object.keys(content).some((key) => content[key] !== held[key]))) {
    setHeld(content);
  }
  return open ? content : held;
}
